import { ReactNode } from 'react';
import './card.scss';

export interface CardProps {
    icon: ReactNode;
    children: ReactNode;
    className?: string;
}

const Card = ({ icon, children, className = '' }: CardProps) => {
    return (
        <div className={`tl-widget icon-box left-aligned item ${className}`.trim()} data-aos="fade-up">
            <div className="icon-wrapper icon-animation">
                <span className="icon-group stacked shape-circle">{icon}</span>
            </div>
            <div className="content">{children}</div>
        </div>
    );
};

export default Card;
